import { gql } from '@apollo/client';

export const DELETE_EXERCISE = gql`
    mutation deleteExercise($id: ID!, $ptId: ID!){
        deleteExercise(id: $id, ptId: $ptId)
    }
`;
